import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CareerQuestion } from '@backrs_ui/grow-ui/src/models/models';
import type { RootState } from '@backrs_ui/grow-ui/src/redux/store';

import { fetchCareerQuestions } from './thunks/survey.thunk';

type SurveyState = Readonly<{
  careerQuestions: CareerQuestion[];
  loading?: boolean;
  error?: string;
}>;

const initialState: SurveyState = {
  careerQuestions: [],
};

export const selectCareerQuestions = (state: RootState) => state.survey.careerQuestions;

export const surveyStateSlice = createSlice({
  name: 'surveyState',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCareerQuestions.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchCareerQuestions.fulfilled, (state, action: PayloadAction<CareerQuestion[]>) => {
        state.careerQuestions = action.payload;
        state.loading = false;
      })
      .addCase(fetchCareerQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});
